import c, { useState as n, useEffect as u } from "react";
import { ScrollableCalendar as h } from "./index15.mjs";
import { CarouselCalendar as w } from "./index16.mjs";
import { IPAD_AIR_WIDTH as f } from "./index17.mjs";
const V = ({
  setMaxDays: t,
  setMinDays: a,
  setWarning: r
}) => {
  const [m, i] = n(!1), [d, o] = n(!0);
  return u(() => {
    const e = window.matchMedia(`(max-width: ${f})`);
    o(e.matches), i(!0);
    const l = (s) => {
      o(s.matches);
    };
    return e.addEventListener("change", l), () => {
      e.removeEventListener("change", l);
    };
  }, []), m ? d ? /* @__PURE__ */ c.createElement(
    h,
    {
      setMaxDays: t,
      setMinDays: a,
      setWarning: r
    }
  ) : /* @__PURE__ */ c.createElement(
    w,
    {
      setMaxDays: t,
      setMinDays: a,
      setWarning: r
    }
  ) : null;
};
export {
  V as DatePicker
};
